import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Gate } from '../../../global/contexts/auth/auth';
import { useCatalog } from '../contexts/standards';
import StandardEditor from '../forms/editor';
import { standardFields } from '../utils/fields';

export default function StandardsCatalog({ create = false }) {
    const catalog = useCatalog();
    const navigate = useNavigate();
    const [params, setParams] = useSearchParams();
    const query = params.get('q') ?? '';
    const track = params.get('track') ?? '';
    function filter(name, value) {
        setParams(previous => { const next = new URLSearchParams(previous); value ? next.set(name, value) : next.delete(name); return next; });
    }
    const filtered = (catalog.data ?? []).filter(item => (!track || item.track === track)
        && `${item.name} ${item.code}`.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
    return <section className="standards">
        <header className="standards__header"><div><h1>Estándares</h1><p>Las reglas del equipo, con versiones que cada repositorio puede adoptar.</p></div>
            {!create && <Gate domain="standards:write"><Link className="standards__primary" to="/admin/standards/new">Crear estándar</Link></Gate>}
        </header>
        {create ? <Gate domain="standards:write"><StandardEditor title="Crear estándar" fields={standardFields}
            initial={{ name: '', code: '', track: 'core', kind: 'standard', description: '' }} action="createStandard"
            onSaved={saved => navigate(`/admin/standards/${saved.id}`)} onCancel={() => navigate('/admin/standards')} /></Gate> : <>
            <div className="standards__filters">
                <label>Buscar estándar<input type="search" value={query} onChange={e => filter('q', e.target.value)} /></label>
                <label>Filtrar pista<select value={track} onChange={e => filter('track', e.target.value)}><option value="">Todas</option><option value="core">Core</option><option value="vite">Vite</option></select></label>
            </div>
            {catalog.isPending && <p>Cargando estándares...</p>}
            {catalog.error && <p role="alert">{catalog.error.message} <button onClick={() => catalog.refetch()}>Reintentar</button></p>}
            {catalog.isSuccess && !catalog.data.length && <div className="standards__card"><h2>Aún no hay estándares</h2><p>Crea el primero, escribe una versión y sus reglas, y publícala para que pueda asociarse a un repositorio.</p></div>}
            {catalog.isSuccess && !!catalog.data.length && !filtered.length && <p>No hay coincidencias para esos filtros.</p>}
            <div className="standards__grid">{filtered.map(item => <Link className="standards__card standards__link" key={item.id} to={`/admin/standards/${item.id}`}>
                <span className="standards__badge">{item.track} · {item.kind === 'ui_guide' ? 'Guía de interfaz' : 'Estándar'}</span>
                <h2>{item.name}</h2><p>{item.description || 'Sin descripción'}</p><small>{item.code} · ID {item.id}</small>
            </Link>)}</div>
        </>}
    </section>;
}
